import useTasksStats from '@/components/deal/tasks/hooks/use-tasks-stats';
import { ProgressRing } from '@/components/ui/progress-ring/progress-ring';
import { cn } from '@/lib/utils';
import type { AssignedTask } from '@/models/registry';

const TasksProgressRing = ({
  assignedTasks,
}: {
  assignedTasks: AssignedTask[];
}) => {
  const { completedPercentage } = useTasksStats(assignedTasks);

  return (
    <ProgressRing
      percentage={completedPercentage}
      className={cn('h-3.5 w-3.5')}
      circleClassName={cn({
        'text-gray-500':
          completedPercentage === 0 || Number.isNaN(completedPercentage),
        'text-red-500': completedPercentage < 100,
        'text-green-500': completedPercentage >= 100,
      })}
    />
  );
};

export default TasksProgressRing;
